/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_appsync_graphqlEndpoint": "https://wckta6btbra3vflgp7wyfhtwgi.appsync-api.eu-west-3.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-3",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-u4thh2625jbdvgi5biipvahfwq",
    "aws_cognito_identity_pool_id": "eu-west-3:44b6d432-e716-433a-a4e5-e2ea0725340d",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_DWwCKfBiu",
    "aws_user_pools_web_client_id": "2pokim7819f0ktrckgsngan8r3",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "collectwitch-storage-b9fb10ff152718-prod",
    "aws_user_files_s3_bucket_region": "eu-west-3"
};


export default awsmobile;
